export const ParametrosConsultaDetalle = [
    {
        codigo: 1,
        proceso: "CONSULTA_POR_CONSECUTIVO_SAT",
        opcion: "CONSECUTIVO SAT"
    }, {
        codigo: 2,
        proceso: "CONSULTA_POR_FECHAS",
        opcion: "FECHAS"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/modelo/ParametrosConsultaDetalle.ts